import axios, { authHeader } from "../../services/HTTPService";
import * as action from "../reducers/previousNewsletterReducer";
import * as articleAction from "../reducers/articleReducer";
const API_URL = process.env.REACT_APP_API_URL;

export const fetchAll = async (
  dispatch,
  {
    fieldTofilter,
    filter,
    fieldToSort,
    sortDirection,
    page,
    pageSize,
  } = {
    fieldTofilter: "title",
    filter: "",
    fieldToSort: "title",
    sortDirection: "asc",
    page: 1,
    pageSize: 8,
  }
) => {
  dispatch(action.setListLoading(true));

  // Build Strapi-compatible parameters
  const params = {
    [`sort[0]`]: `${fieldToSort}:${sortDirection}`,
    [`pagination[page]`]: page,
    [`pagination[pageSize]`]: pageSize,
    populate: '*', // Populate all related fields including pdf
    'filters[current_newsletter][$eq]': false, // Only get previous newsletters
  };

  // Add filter if provided
  if (filter && fieldTofilter) {
    params[`filters[${fieldTofilter}][$containsi]`] = filter;
  }

  return axios
    .get(API_URL + `/api/medicare-newsletters`, {
      headers: authHeader(),
      params,
    })
    .then(({ data }) => {
      const meta = data?.meta;
      dispatch(action.setPreviousNewsletterList({ data }));
      dispatch(action.setMetadata({ meta }));
      dispatch(action.setListLoading(false));
    })
    .catch((error) => {
      dispatch(
        action.setPreviousNewsletterError({
          error: error?.response?.data?.error?.message,
        })
      );
      dispatch(action.setListLoading(false));
    });
};

export const fetchDetails = async (dispatch, id) => {
  return axios
    .get(API_URL + `/api/medicare-newsletters/${id}`, {
      headers: authHeader(),
      params: {
        populate: '*', // Populate all related fields including pdf
      }
    })
    .then(({ data }) => {
      dispatch(action.setPreviousNewsletterDetail({ data }));
    })
    .catch((error) => {
      dispatch(
        action.setPreviousNewsletterError({
          error: error?.response?.data?.error?.message,
        })
      );
    });
};

export const create = async (dispatch, body) => {
  return axios
    .post(API_URL + "/api/medicare-newsletters", body, { headers: authHeader() })
    .then(({ data }) => {
      dispatch(action.setPreviousNewsletter({ data }));
    })
    .catch((error) => {
      dispatch(
        action.setPreviousNewsletterError({
          error: error?.response?.data?.error?.message,
        })
      );
    });
};

export const update = async (dispatch, id, body) => {
  return axios
    .put(API_URL + `/api/medicare-newsletters/${id}`, body, {
      headers: authHeader(),
    })
    .then(({ data }) => {
      dispatch(action.setPreviousNewsletter({ data }));
    })
    .catch((error) => {
      dispatch(
        action.setPreviousNewsletterError({
          error: error?.response?.data?.error?.message,
        })
      );
      throw error; // Re-throw the error so it can be caught in components
    });
};

export const remove = async (dispatch, id, params) => {
  return axios
    .delete(API_URL + `/api/medicare-newsletters/${id}`, { headers: authHeader() })
    .then(async () => {
      await fetchAll(dispatch, params);
    })
    .catch((error) => {
      dispatch(
        action.setPreviousNewsletterError({
          error: error?.response?.data?.error?.message,
        })
      );
    });
};

export const reOrder = async (dispatch, body, filterParams) => {
  return axios
    .put(API_URL + `/api/medicare-newsletters/reOrder`, body, { headers: authHeader() })
    .then(({ data }) => {
      console.log('data', filterParams)
      fetchAll(dispatch, filterParams);
    })
    .catch((error) => {
      dispatch(
        articleAction.setArticleError({ error: error?.response?.data?.error?.message })
      );
    });
};